
<div class="activitygauge" :class="{ nodata: !svi }" :style="`width:${width}px;`">
  <highcharts :options="chart"></highcharts>
</div>
